<div class="cx-one-ui">
    <div class="modal-header cxone-modal-header">
        <div class="cxone-modal-title">{{contactNoLocalized}}: {{ contactNo }}</div>
        <div class="modal-close">
            <button type="button" class="icon-btn fill-iconDefault" (click)="close()">
                <svg class="icon-12">
                    <use href="../../App_Themes/CXone/icons/close.svg#close"></use>
                </svg>
            </button>
        </div>     
    </div>
        <div class="modal-body cxone-modal-body">
            <div class="details-header">
                <div *ngIf="data?.CurrentStateName !== null" class='details-container'>
                    <div class="state-container">
                        <div class="time-header">{{data?.CurrentStateName}}</div>
                        <div class="time-box time-text">{{data?.StateTimeDisplay}}</div>
                    </div>
                    <div class="state-container">
                        <div class="time-header">{{totalLocalized}}</div>
                        <div class="time-box time-text">{{data?.TotalTimeDisplay}}</div>
                    </div>
                </div>
            </div>
            <div class="table-container">
                <div class="grid-container">
                    <ag-grid-angular 
                    #contactListZoomGrid
                    *ngIf="gridOptions"
                    class="ag-theme-balham flex-fill"
                    [gridOptions]="gridOptions">
                </ag-grid-angular>
                </div>
            </div>
        </div>
    <div class="modal-footer cxone-modal-footer"></div>
</div>